// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { ReactElement } from 'react';

import { Route } from 'react-router-dom';

import { Exercises } from '../pages/I.LAB';

function ExercisesRoutes(): ReactElement {
  return (
    <>
      <Route path="/ilab/exercises" exact component={Exercises.Main} />
      <Route
        path="/ilab/exercises/list/:segmentName"
        exact
        component={Exercises.ExercisesList}
      />
      <Route
        path="/ilab/exercises/details/:exerciseId"
        exact
        component={Exercises.ExerciseDetails}
      />
      <Route
        path="/ilab/exercises/cadaster/:segmentName"
        exact
        component={Exercises.ExerciseCadaster}
      />
      <Route
        path="/ilab/exercises/edit/:exerciseId"
        exact
        component={Exercises.EditExercise}
      />
      <Route
        path="/ilab/exercises/edit/:exerciseId/video"
        exact
        component={Exercises.ShowExerciseVideo}
      />
    </>
  );
}

export default ExercisesRoutes;
